import { render, staticRenderFns } from "./ContainerSize.vue?vue&type=template&id=4665c838"
import script from "./ContainerSize.vue?vue&type=script&lang=ts"
export * from "./ContainerSize.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4665c838')) {
      api.createRecord('4665c838', component.options)
    } else {
      api.reload('4665c838', component.options)
    }
    module.hot.accept("./ContainerSize.vue?vue&type=template&id=4665c838", function () {
      api.rerender('4665c838', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiSize/ContainerSize.vue"
export default component.exports